import type { DynVarOption } from '../hooks/useDynamicVariables';

/**
 * Renders agent instructions as read-only preview text: recognized
 * `{token}` variables show as pill chips with their human-readable label
 * (matching the editable AgentVariableEditor); unrecognized tokens are left
 * as plain text.
 */
export const renderInstructionsPreview = (
  text: string,
  dynVarOptions: DynVarOption[]
) => {
  const str = String(text || '');
  const byValue = new Map(dynVarOptions.map((o) => [o.value, o]));
  const parts = str.split(/(\{[^}]+\})/g);

  return parts.map((part, i) => {
    const isToken = /^\{[^}]+\}$/.test(part);
    if (!isToken) return <span key={i}>{part}</span>;

    const option = byValue.get(part.slice(1, -1));
    if (!option) return <span key={i}>{part}</span>;

    return (
      <span key={i} className='agentVarPill'>
        {option.label}
      </span>
    );
  });
};
